module.exports = __webpack_public_path__ + "static/assets/b426caa86e283eeef95134cede917635.png";